import { render, staticRenderFns } from "./swPostPreviewCard.vue?vue&type=template&id=284d92ba&"
import script from "./swPostPreviewCard.vue?vue&type=script&lang=js&"
export * from "./swPostPreviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports